import { render, staticRenderFns } from "./spatialSpanIcon.vue?vue&type=template&id=df5a742e&"
import script from "./spatialSpanIcon.vue?vue&type=script&lang=js&"
export * from "./spatialSpanIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports